(function () {
  'use strict';

  if (customElements.get('mb-bike-selector')) return;

  class MbBikeSelector extends HTMLElement {
    constructor() {
      super();
      this.onBrandChange = this.onBrandChange.bind(this);
      this.onModelChange = this.onModelChange.bind(this);
      this.onYearChange = this.onYearChange.bind(this);
    }

    connectedCallback() {
      this.productId = this.dataset.productId;
      this.productUrl = this.dataset.productUrl;
      this.brandSelect = this.querySelector('[data-bike-option="brand"]');
      this.modelSelect = this.querySelector('[data-bike-option="model"]');
      this.yearSelect = this.querySelector('[data-bike-option="year"]');
      this.variantData = this.getVariantData();
      this.productForm = document.getElementById(`product-form-${this.productId}`);
      this.variantInput = this.productForm ? this.productForm.querySelector('input[name="id"]') : document.getElementById('variant_id');
      this.productSelect = document.getElementById('productSelect');
      this.addButton = this.productForm ? this.productForm.querySelector('[name="add"]') : null;
      this.addButtonText = this.addButton ? this.addButton.querySelector('#AddToCartText') : null;
      this.addButtonParent = this.productForm ? this.productForm.querySelector('.product-form__item--submit') : null;
      this.checkoutButtonParent = this.productForm ? this.productForm.querySelector('.product-form__item--checkout') : null;
      this.variantSku = document.getElementById('variantSku');
      this.currentVariant = null;

      if (!this.brandSelect || !this.modelSelect || !this.yearSelect || !this.variantData.length) return;

      this.populateBrands();
      this.resetSelectionState();

      this.brandSelect.addEventListener('change', this.onBrandChange);
      this.modelSelect.addEventListener('change', this.onModelChange);
      this.yearSelect.addEventListener('change', this.onYearChange);
    }

    disconnectedCallback() {
      if (!this.brandSelect || !this.modelSelect || !this.yearSelect) return;
      this.brandSelect.removeEventListener('change', this.onBrandChange);
      this.modelSelect.removeEventListener('change', this.onModelChange);
      this.yearSelect.removeEventListener('change', this.onYearChange);
    }

    getVariantData() {
      const json = this.querySelector('[data-variants-json]');
      if (!json) return [];
      try {
        return JSON.parse(json.textContent);
      } catch (error) {
        console.warn('MB bike selector: variant JSON could not be parsed.', error);
        return [];
      }
    }

    unique(values) {
      return [...new Set(values.filter((value) => value !== null && value !== undefined && String(value).trim() !== ''))];
    }

    populateSelect(select, placeholder, values) {
      select.innerHTML = '';
      const placeholderOption = document.createElement('option');
      placeholderOption.value = '';
      placeholderOption.textContent = placeholder;
      select.appendChild(placeholderOption);

      values.forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
    }

    populateBrands() {
      const brands = this.unique(this.variantData.map((variant) => variant.option1 || (variant.options && variant.options[0])));
      this.populateSelect(this.brandSelect, 'Please select a brand', brands);
    }

    resetSelectionState() {
      this.populateSelect(this.modelSelect, 'Please select a model', []);
      this.populateSelect(this.yearSelect, 'Please select a year', []);
      this.modelSelect.disabled = true;
      this.yearSelect.disabled = true;
      this.currentVariant = null;
      this.setVariantInput('');
      this.setAddButtonDisabled(true);
    }

    onBrandChange() {
      const brand = this.brandSelect.value;

      this.populateSelect(this.modelSelect, 'Please select a model', []);
      this.populateSelect(this.yearSelect, 'Please select a year', []);
      this.modelSelect.disabled = true;
      this.yearSelect.disabled = true;
      this.currentVariant = null;
      this.setVariantInput('');
      this.setAddButtonDisabled(true);

      if (!brand) return;

      const models = this.unique(
        this.variantData
          .filter((variant) => (variant.option1 || variant.options[0]) === brand)
          .map((variant) => variant.option2 || variant.options[1])
      );

      this.populateSelect(this.modelSelect, 'Please select a model', models);
      this.modelSelect.disabled = false;
    }

    onModelChange() {
      const brand = this.brandSelect.value;
      const model = this.modelSelect.value;

      this.populateSelect(this.yearSelect, 'Please select a year', []);
      this.yearSelect.disabled = true;
      this.currentVariant = null;
      this.setVariantInput('');
      this.setAddButtonDisabled(true);

      if (!brand || !model) return;

      const years = this.unique(
        this.variantData
          .filter((variant) => (variant.option1 || variant.options[0]) === brand && (variant.option2 || variant.options[1]) === model)
          .map((variant) => variant.option3 || variant.options[2])
      );

      this.populateSelect(this.yearSelect, 'Please select a year', years);
      this.yearSelect.disabled = false;
    }

    onYearChange() {
      const brand = this.brandSelect.value;
      const model = this.modelSelect.value;
      const year = this.yearSelect.value;

      this.currentVariant = null;
      this.setVariantInput('');
      this.setAddButtonDisabled(true);

      if (!brand || !model || !year) return;

      const matchedVariant = this.variantData.find((variant) => {
        const options = variant.options || [variant.option1, variant.option2, variant.option3];
        return options[0] === brand && options[1] === model && options[2] === year;
      });

      if (!matchedVariant) return;

      this.currentVariant = matchedVariant;
      this.setVariantInput(matchedVariant.id);
      this.updateProductSelect(matchedVariant.id);
      this.updateAllProductFormVariantInputs(matchedVariant.id);
      this.updateSku(matchedVariant);
      this.updateMedia(matchedVariant);
      this.updateUrl(matchedVariant);
      this.renderProductInfo(matchedVariant);
      this.setAddButtonForVariant(matchedVariant);
    }

    setVariantInput(value) {
      if (!this.variantInput) return;
      this.variantInput.value = value;
      this.variantInput.setAttribute('value', value);
      this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateAllProductFormVariantInputs(variantId) {
      const container = this.closest('.product-template__container') || document;
      const inputs = container.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
      inputs.forEach((input) => {
        input.value = variantId;
        input.setAttribute('value', variantId);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    updateProductSelect(variantId) {
      if (!this.productSelect) return;
      this.productSelect.value = variantId;
      Array.from(this.productSelect.options).forEach((option) => {
        option.selected = option.value === String(variantId);
      });
    }

    setAddButtonDisabled(disabled) {
      if (this.addButton) this.addButton.disabled = disabled;
      if (this.addButtonParent) {
        this.addButtonParent.classList.toggle('mb-bike-selector-disabled', disabled);
        if (disabled) {
          this.addButtonParent.classList.remove('soldout');
          this.addButtonParent.removeAttribute('data-toggle');
          this.addButtonParent.removeAttribute('data-target');
        }
      }
      if (this.checkoutButtonParent) {
        this.checkoutButtonParent.classList.toggle('mb-bike-selector-disabled', disabled);
        if (disabled) {
          this.checkoutButtonParent.setAttribute('disabled', true);
        } else {
          this.checkoutButtonParent.removeAttribute('disabled');
        }
      }
    }

    setAddButtonForVariant(variant) {
      const isAvailable = Boolean(variant.available);
      const inventoryQuantity = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : 0;
      const isPreorder = variant.inventory_policy === 'continue' && inventoryQuantity < 1;

      this.setAddButtonDisabled(false);

      if (!this.addButtonParent || !this.addButtonText) return;

      if (!isAvailable) {
        this.addButtonParent.classList.add('soldout');
        this.addButtonParent.setAttribute('data-toggle', 'modal');
        this.addButtonParent.setAttribute('data-target', '#Form_newletter');
        this.addButtonText.textContent = window.variantStrings && window.variantStrings.notify_me ? window.variantStrings.notify_me : 'Notify me';
        if (this.checkoutButtonParent) this.checkoutButtonParent.setAttribute('disabled', true);
        return;
      }

      this.addButtonParent.classList.remove('soldout');
      this.addButtonParent.removeAttribute('data-toggle');
      this.addButtonParent.removeAttribute('data-target');
      this.addButtonText.textContent = isPreorder
        ? ((window.variantStrings && window.variantStrings.preorder) ? window.variantStrings.preorder : 'Pre-order')
        : ((window.variantStrings && (window.variantStrings.addTobag || window.variantStrings.addToCart)) ? (window.variantStrings.addTobag || window.variantStrings.addToCart) : 'Add to cart');
      if (this.checkoutButtonParent) this.checkoutButtonParent.removeAttribute('disabled');
    }

    updateSku(variant) {
      if (!this.variantSku) return;
      this.variantSku.textContent = variant.sku || '';
    }

    updateMedia(variant) {
      if (!variant || !variant.featured_media) return;
      const newMedia = document.querySelector(`[data-media-id="${this.productId}-${variant.featured_media.id}"]`);
      if (!newMedia) return;
      const activeItems = document.querySelectorAll('.proFeaturedImage .item');
      activeItems.forEach((item) => item.classList.remove('act'));
      newMedia.classList.add('act');
      if (newMedia.parentElement) window.setTimeout(() => newMedia.parentElement.scroll(0, 0));
    }

    updateUrl(variant) {
      if (!variant || !this.productUrl || this.dataset.updateUrl === 'false') return;
      if (!document.querySelectorAll('.template-product').length || this.closest('#content_quickview')) return;
      window.history.replaceState({}, '', `${this.productUrl}?variant=${variant.id}`);
    }

    renderProductInfo(variant) {
      if (!variant || !this.productUrl || !this.productId) return;
      fetch(`${this.productUrl}?variant=${variant.id}&section_id=${this.productId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const priceId = `ProductPrice-${this.productId}`;
          const destination = document.getElementById(priceId);
          const source = html.getElementById(priceId);
          if (source && destination) destination.innerHTML = source.innerHTML;
          if (typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function' && typeof shopCurrency !== 'undefined' && window.jQuery) {
            const selectedCurrency = window.jQuery('#currencies span.selected').attr('data-currency');
            if (selectedCurrency) Currency.convertAll(shopCurrency, selectedCurrency);
          }
        })
        .catch((error) => {
          console.warn('MB bike selector: product info refresh failed.', error);
        });
    }
  }

  customElements.define('mb-bike-selector', MbBikeSelector);
})();
